/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface OTPViaEmailMethodOptions
 */
export interface OTPViaEmailMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPViaEmailMethodOptions
     */
    method: FactorMethod;
}

/**
 * Check if a given object implements the OTPViaEmailMethodOptions interface.
 */
export function instanceOfOTPViaEmailMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function OTPViaEmailMethodOptionsFromJSON(json: any): OTPViaEmailMethodOptions {
    return OTPViaEmailMethodOptionsFromJSONTyped(json, false);
}

export function OTPViaEmailMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPViaEmailMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function OTPViaEmailMethodOptionsToJSON(value?: OTPViaEmailMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
    };
}

